import * as Yup from 'yup';
import { UnitType } from '../entities';

export interface UnitForm {
  label: string;
  number: string;
  disabled: boolean;
  size?: string;
  type: UnitType;
  sectionId?: string;
}

export type UnitFormShape = {
  [key in keyof UnitForm]?: any;
};

export const schema = Yup.object().shape<UnitFormShape>({
  label: Yup.string().required('Digite o nome'),
  number: Yup.string().required('Digite o número'),
  type: Yup.string().required('Selecione o tipo'),
});
